<template>
  <main-input-dialog
    :is-visible.sync="computedIsVisible"
    :title-translation="$i18n.t('admin.descAttributes.editDescs', { value: editingDataSource.verbose_name })"
    dialog-width="40%"
    min-body-height="350px"
    agree-text="dialog.agreeSave"
    :inputs="inputs"
    @agree="agree"
    :loading="loading"
  >
    <template v-for="(input, idx) of inputs" #[`${input.name}.input`]="data">
      <v-col cols="6" :key="idx">
        <data-input v-bind="data" v-model="descAttributes[input.name]" />
      </v-col>
    </template>
  </main-input-dialog>
</template>
<script>
import { call } from 'vuex-pathify';
const NUMBER_OF_DESCS_ATTRIBUTES = 5;

import DataInput from '@/components/DataInput';
import MainInputDialog from '@/components/MainInputDialog';

export default {
  name: 'DataSourceDescsEditing',
  components: { DataInput, MainInputDialog },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    editingDataSource: {
      type: Object,
    },
  },
  computed: {
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(value) {
        this.$emit('update:isVisible', value);
      },
    },
    arrayOfIndexes() {
      return Array.from({ length: NUMBER_OF_DESCS_ATTRIBUTES }, (_, i) => i + 1);
    },
    inputs() {
      return this.arrayOfIndexes.reduce((total, current) => {
        total.push({
          name: '' + current,
          dataType: { name: 'select' },
          items: this.attributes,
          straightTitle: this.$i18n.t('admin.descAttributes.descAttribute', { value: current }),
          rules: current === 1 ? [v => !!v || 'rules.required'] : [],
          clearable: current !== 1,
          leftCol: 5,
          cols: 11,
          readonly: this.loading,
        });
        return total;
      }, []);
    },
    attributes() {
      return this.editingDataSource.attributes_schema.attributes
        .filter(attribute => !['geometric'].includes(attribute.data_type.name))
        .map(attribute => {
          return {
            text: attribute.verbose_name,
            value: attribute.name,
          };
        });
    },
  },
  data: () => ({
    descAttributes: {},
    loading: false,
  }),
  methods: {
    editDataSource: call('layers/editDataSourceMetadata'),
    getLayersMetadata: call('layers/getLayersMetadata'),
    async agree() {
      this.loading = true;
      try {
        let firstDescAttributeName = null;
        const descAttributes = {};
        this.arrayOfIndexes.forEach(index => {
          if (index === 1) firstDescAttributeName = this.descAttributes[index];
          else descAttributes[index] = this.descAttributes[index] || null;
        });
        const payload = {
          name: this.editingDataSource.name,
          body: {
            desc_attribute_name: firstDescAttributeName,
            desc_attributes: descAttributes,
          },
        };
        await this.editDataSource(payload);
        await this.getLayersMetadata({
          with_attributes_schema: true,
          with_layers: true,
          with_last_edit: true,
          with_owner: true,
        });
        this.computedIsVisible = false;
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    computedIsVisible: {
      handler(nV) {
        if (nV) {
          const {
            desc_attributes: descAttributes,
            attributes_schema: { desc_attribute_name: firstDescAttributeName },
          } = this.editingDataSource;
          this.$set(
            this,
            'descAttributes',
            this.arrayOfIndexes.reduce((total, current) => {
              total[current] = current === 1 ? firstDescAttributeName : descAttributes[current] || null;
              return total;
            }, {})
          );
        }
      },
      immediate: true,
    },
  },
};
</script>
